export const APP_TIMEZONE = 'America/Bogota';

const HAS_TIMEZONE_SUFFIX = /(?:[zZ]|[+-]\d{2}:\d{2})$/;

export function parseApiDateTime(value?: string | null): Date | null {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const normalized = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T');
  const parseValue = HAS_TIMEZONE_SUFFIX.test(normalized) ? normalized : `${normalized}Z`;
  const parsed = new Date(parseValue);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDateTimeEsCO(value?: string | null, fallback = '—'): string {
  const date = parseApiDateTime(value);
  if (!date) {
    return fallback;
  }

  return date.toLocaleString('es-CO', {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: APP_TIMEZONE,
  });
}
